export const SEND_MOOD = 'SEND_MOOD'
export const GET_MOODS = 'GET_MOODS' // получение статистики по всем пользователям
export const GET_EXCEL = 'GET_EXCEL' // получение статистики как Excel
export const CHECK_METER_NEED = 'CHECK_METER_NEED' // получение признака необходимости показать окно
